export { default as EN } from "./en.json";
export const PROGRAMMES_NAMESPACE = "programmes";
